export enum WaitingListStatusEnum {
  waiting = "waiting",
  added = "added",
  removedByAdmin = "removedByAdmin",
  removedByPassenger = "removedByPassenger",
}

export type TWaitingListStatus = `${WaitingListStatusEnum}`;
